enum InviteStatuses {
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
  PENDING = 'pending',
  SENT = 'sent',
  JOINED = 'joined',
}

export default InviteStatuses;
